import React from "react";

import GalleryData from "../Gallery.json";
import { Helmet } from "react-helmet";

function Gallery() {
	return (
		<>
			<Helmet>
				<title>Gallery | University of Education</title>
			</Helmet>
			<div className="PageContainer">
				<div className="GalleryContainer">
					<div className="GalleryBanner HeaderImg">
						<img src="/Images/Banner/5.jpg" alt="Gallery-banner" />
					</div>

					<div className="GalleryRow" data-aos="fade-up">
						<div className="GalleryTitle" data-aos="fade-up">
							<h5 id="Secondary_Heading" data-aos="fade-up">
								Recent Gallery Updates
							</h5>
						</div>

						<div className="GalleryCardContainer" data-aos="fade-up">
							{GalleryData.Recent_Updates.map((item, index) => {
								return (
									<div className="GalleryCard" data-aos="fade-up" key={index}>
										<img src={item.img} alt="img" style={{ objectPosition: item.position || 'center' }} />
										<p>{item.desc}</p>
									</div>
								);
							})}
						</div>
					</div>

					<div className="GalleryRow" data-aos="fade-up">
						<div className="GalleryTitle" data-aos="fade-up">
							<h5 id="Secondary_Heading" data-aos="fade-up">
								Campus Life
							</h5>
						</div>

						<div className="GalleryCardContainer" data-aos="fade-up">
							{GalleryData.Campus_Life.map((campus, index) => {
								return (
									<div className="GalleryCard" data-aos="fade-up" key={index}>
										<img src={campus.img} alt="img" style={{ objectPosition: campus.position || 'center' }} />
										<p>{campus.desc}</p>
									</div>
								);
							})}
						</div>
					</div>


					<div className="GalleryRow" data-aos="fade-up">
						<div className="GalleryTitle" data-aos="fade-up">
							<h5 id="Secondary_Heading" data-aos="fade-up">
								Events
							</h5>
						</div>

						<div className="GalleryCardContainer" data-aos="fade-up">
							{GalleryData.Events.map((events, index) => {
								return (
									<div className="GalleryCard" data-aos="fade-up" key={index}>
										<img src={events.img} alt="img" style={{ objectPosition: events.position || 'center' }} />
										<p>{events.desc}</p>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Gallery;
